import { type VueConstructor } from 'vue';

export default {
    install(Vue: VueConstructor) {
        Vue.prototype.$bus = new Vue({});
    },
};
